import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ComputationService {
  computationUrl = this.ConfigService.getAPIBaseUrl() + 'api/Computation/'
  computationAccountingPeriodUrl = this.ConfigService.getAPIBaseUrl() + 'api/Computations_AccountingPeriod/'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  getcomputationdata(id) {
    return this.http.get(this.computationUrl + 'getcomputationdata?id=' + id);
  }
  insertcomputationdata(data) {
    const httpoptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.computationUrl + 'Insertcomputationdata', data, httpoptions)
  }
  getAllComputationsAccountingPeriods(APPeriodId) {
    return this.http.get(this.computationAccountingPeriodUrl + 'GetAllComputationsAccountingPeriod?APPeriodId=' + APPeriodId)
  }
  getComputationsAccountingPeriod(computationAPPeriodId) {
    return this.http.get(this.computationAccountingPeriodUrl + 'GetComputationsAccountingPeriod?ComputationsAPPeriodId=' + computationAPPeriodId)
  }
  deleteComputationAccountingPeriod(computationAPPeriodId) {
    const httpoptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.computationAccountingPeriodUrl + 'DeleteComputationsAccountingPeriod?ComputationsAPPeriodId=' + computationAPPeriodId, httpoptions)
  }
  deleteAllComputationAccountingPeriod(APPeriodId) {
    const httpoptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.computationAccountingPeriodUrl + 'DeleteAllComputationsAccountingPeriod?APPeriodId=' + APPeriodId, httpoptions)
  }
  insertComputationsAccountingPeriod(data) {
    return this.http.post(this.computationAccountingPeriodUrl + 'InsertComputationsAccountingPeriod', data);
  }
}
